export default __webpack_public_path__ + "static/media/space.d6be3dbd.jpg";